<p-autoComplete #inputElement
	[inputId]="uid"
	[(ngModel)]="selectedElement"
	[suggestions]="filteredSelectList"
	[minLength]="minLength"
	[dropdown]="showDropdownIcon"
	[forceSelection]="true"
	(completeMethod)="filterSelectList($event)"
	(onSelect)="emitSelectedElement()"
	optionLabel="nonexistingdummy"> <!-- "nonexistingdummy" bewirkt, dass das Eingabefeld nach der Auswahl gelöscht wird -->
	
	<ng-template let-item pTemplate="item">        
           {{item.data.defaulttext}}
    </ng-template>
</p-autoComplete>
